export const logoStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    background: "black",
    zIndex: 123,
    padding: "10px 12px 0",
};
